import { render, staticRenderFns } from "./AdjustResultsPreQuery.vue?vue&type=template&id=c5b380b4&lang=pug&"
import script from "./AdjustResultsPreQuery.vue?vue&type=script&lang=ts&"
export * from "./AdjustResultsPreQuery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports